import { render, staticRenderFns } from "./ExtAstaDxPreview.vue?vue&type=template&id=2fa9c278"
import script from "./ExtAstaDxPreview.vue?vue&type=script&lang=js"
export * from "./ExtAstaDxPreview.vue?vue&type=script&lang=js"
import style0 from "./ExtAstaDxPreview.vue?vue&type=style&index=0&id=2fa9c278&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa9c278')) {
      api.createRecord('2fa9c278', component.options)
    } else {
      api.reload('2fa9c278', component.options)
    }
    module.hot.accept("./ExtAstaDxPreview.vue?vue&type=template&id=2fa9c278", function () {
      api.rerender('2fa9c278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtAstaDxPreview.vue"
export default component.exports